export enum Default {
  ADMINISTRATOR = 'ADMIN',
  // PUBLIC = 'PUBLIC',
}
